<template>
  <v-data-table
    :footer-props="{ 'items-per-page-options': [25, 50, 100, 500, -1] }"
    :headers="headerList"
    :item-key="idAttributeName"
    :items="entityListFiltered"
    :single-select="false"
    :value="entityListSelected"
    @input="updateEntityListSelected"
    class="transparent"
    data-cy="listTable"
    no-data-text="There are no results with the current search."
    show-select
  >
    <template v-slot:[`header.needsInfo`]="{ header }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span class="d-inline" v-bind="attrs" v-on="on">
            {{ header.text }}
          </span>
        </template>
        <span
          >The indicated users require more information<br />before they can be
          exported for Epic.</span
        >
      </v-tooltip>
    </template>

    <template
      v-for="{ name: attributeName } in attributeListSelected"
      v-slot:[`item.${attributeName}`]="{ value }"
      >{{ format(value) }}</template
    >

    <template v-slot:[`item.needsInfo`]="{ item }">
      <v-tooltip v-if="completionRequired(item)" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            class="mr-2"
            icon
            open-on-click
            v-bind="attrs"
            v-on="on"
            small
            ><v-icon>fas fa-exclamation-circle</v-icon></v-btn
          >
        </template>
        <span>Missing fields required by Epic based on previous answers</span>
      </v-tooltip></template
    >
    <template v-slot:[`item.edit`]="{ item }">
      <router-link v-if="item['entraId']"
      :data-cy="`${entityName}${item[idAttributeName]}-edit`"
      :to="{
        name: `${entityName}Edit`,
        params: { id: item['entraId'] },
      }"
        >Edit</router-link>
        <!-- <div v-if="serviceAreaId !== null && item.email !== null" >
          <a 
            :href="`/member/ochin-crowd-sa${serviceAreaId}/user/${encodeURIComponent(item.email)}`">
              New Edit
          </a>
        </div> -->
    </template>
  </v-data-table>
</template>

<script>
import conditionalUtil from "@/lib/conditionalUtil";
import moment from "moment";
import { mapState } from "vuex";

const headerListPrepend = [
  {
    text: `Additional Information Required`,
    value: "needsInfo",
    width: "30px",
  },
];

const headerListAppend = [
  {
    text: "Edit",
    value: "edit",
  },
];

export default {
  computed: {
    headerList() {
      const { attributeListSelected } = this;

      // Format for table rendering
      const headerList = attributeListSelected.map(({ label, name }) => ({
        text: label,
        value: name,
      }));

      // Add additional headers
      return [].concat(headerListPrepend, headerList, headerListAppend);
    },
    ...mapState({
      serviceAreaId: state => state.organization.record.serviceAreaId,
    }),
  },
  methods: {
    format(value) {
      if (Array.isArray(value)) {
        return value.join(", ");
      }

      return value;
    },
    completionRequired(entity) {
      const { attributeList } = this;

      return attributeList.reduce((acc, attribute) => {
        const { conditionalList, name: attributeName } = attribute;
        const value = entity[attributeName];

        if (!(value === undefined || value === null)) {
          return acc;
        }

        const isShown = !!conditionalUtil.resolveAction({
          actionId: "show",
          conditionalList,
          defaultValue: true,
          entity,
        });

        const isRequired = !!conditionalUtil.resolveAction({
          actionId: "require",
          conditionalList,
          entity,
        });

        const needsInfo = isShown && isRequired;

        return acc || needsInfo;
      }, false);
    },
    formatDate(dateString) {
      return moment(dateString).format("YYYY-MM-DD");
    },
    updateEntityListSelected(updatedEntityListSelected) {
      this.$emit("update-entity-list-selected", updatedEntityListSelected);
    },
  },
  model: {
    prop: "entityListSelected",
    event: "update",
  },
  props: {
    attributeList: {
      required: true,
      type: Array,
    },
    attributeListSelected: {
      required: true,
      type: Array,
    },
    entityListFiltered: {
      required: true,
      type: Array,
    },
    entityListSelected: {
      required: true,
      type: Array,
    },
    entityName: {
      required: true,
      type: String,
    },
    idAttributeName: {
      required: true,
      type: String,
    },
  },
};
</script>
